import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../form/Select';
import { incomes } from '../../utilities/inPageLeadFormData';
import { handleBlurEvent } from '../../utilities/utilities';

export const WealthRangeSelectInputComponent = React.forwardRef(({
  value,
  onChange,
  error,
  errorMessage,
}, ref) => (
  <Select
    id="in-page-lead-form-wealth-range-select"
    label='Net Worth'
    ref={ref}
    name='wealthRange'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={handleBlurEvent}
    options={incomes}
    required={true}
    customTheme={'leads'}>
    {incomes.map(
      option => <option
        key={option.name}
        value={option.value}
        disabled={option.disabled}>
        {option.name}
      </option>,
    )}
  </Select>
));

WealthRangeSelectInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default WealthRangeSelectInputComponent;
